import { ViewPlugin, Decoration, EditorView } from "@codemirror/view"
import { syntaxHighlighting, defaultHighlightStyle } from "@codemirror/language"
import { markdown } from "@codemirror/lang-markdown"
import { syntaxTree } from "@codemirror/language"

// TODO: Review & remove unnecessary imports
// import tagParser from "./markdoc/utils/tagParser"
import highlightStyle from "./markdoc/utils/highlightStyle"
import renderBlock from "./markdoc/utils/renderBlock"

import { routeDecoration } from "./markdoc/decorationRouter"

class RichEditorPlugin {
  constructor(view, config = {}) {
    this.mode = config.mode || "show";
    this.decorations = this.process(view, this.mode);
  }

  update(update) {
    if (update.docChanged || update.viewportChanged || (this.mode === "edit" && update.selectionSet)) {
      this.decorations = this.process(update.view, this.mode);
    }
  }

  process(view, mode) {
    const widgets = [];
    const tree = syntaxTree(view.state);

    if (!tree) {
      return Decoration.set(widgets);
    }

    for (const { from, to } of view.visibleRanges) {
      tree.iterate({
        from,
        to,
        enter(node) {
          return routeDecoration(node, view, widgets, mode);
        },
      });
    }

    return Decoration.set(widgets);
  }
}

export default function markdocRichEditorPlugin(config = {}) {
  return ViewPlugin.define(
    (view) => new RichEditorPlugin(view, config),
    {
      decorations: (v) => v.decorations,
      provide: (v) => [
        renderBlock(config.markdoc, config.mode), // NOTE: Block items need to be rendered in a specific way.
        syntaxHighlighting(highlightStyle),
        markdown(config.lezer),
        EditorView.lineWrapping
      ],
      eventHandlers: {
        mousedown({ target }, view) {
          if (target instanceof Element && target.matches('.cm-markdoc-renderBlock *'))
            view.dispatch({ selection: { anchor: view.posAtDOM(target) } });
        }
      }
    }
  );
}
